// extracted by mini-css-extract-plugin
export default {"Comments__button":"styles_Comments__button__7sfhP","Comments__button__text":"styles_Comments__button__text__dv06j","Comments__modal":"styles_Comments__modal__hwyuY"};